import { api } from "../Configurations/axios";
import { ContactBaseModel, ContactPhoneFinepModel } from "../Models/ContactPhoneFinepModel";

const GetContactFinepByCompanyAndReference = async (id: string, reference: 0 | 1) => {
    try {
        var result = await api.get(`/ContactFINEP/GetByCompanyFINEPAndType/${id}/${reference}`);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllContactPhone = async (id: string) => {
    try {
        var result = await api.get(`/ContactPhoneFINEP/GetByContact/${id}`);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


const CreateContactFinep = async (contact: ContactBaseModel) => {
    try {
        var result = await api.post(`/ContactFINEP/CreateContactFINEP`, contact);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateContactPhoneFinep = async (contact: ContactPhoneFinepModel) => {
    try {
        var result = await api.post(`/ContactPhoneFINEP/CreateContactPhoneFINEP`, contact);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteContactPhoneFinep = async (id: string) => {
    try {
        var result = await api.delete(`/ContactPhoneFINEP/DeleteById/${id}`);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const EditContactFinep = async (contact: ContactBaseModel) => {
    try {
        var result = await api.put(`/ContactFINEP/UpdateContactFINEP`, contact);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateContactFinepProps{
    companyFINEPId: string;
    isContentValid: boolean;
    userEmail: string;
}

const ValidateContactFinep = async (contact: ValidateContactFinepProps) => {
    try {
        var result = await api.put(`/ContactFINEP/ValidateContactFINEP`, contact);
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    CreateContactFinep,
    CreateContactPhoneFinep,
    EditContactFinep,
    GetContactFinepByCompanyAndReference,
    GetAllContactPhone,
    DeleteContactPhoneFinep,
    ValidateContactFinep
}